module.exports = {"TXTMOB_Buy_inX":{"id":"TXTMOB_Buy_inX","defaultMessage":"Вход:"}}